export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">关于我们</h2>
        <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            51视频是一个专注于高清免费在线观影的内容平台，致力于为全球华语用户提供
            流畅、清晰、丰富的影视观看体验。自上线以来，我们始终秉持"免费、高清、无广告干扰"
            的核心理念，让每一位用户都能轻松享受观影乐趣。
          </p>
          <p>
            平台汇聚了超过10万部优质影视资源，涵盖热门电影、高分剧集、人气综艺、
            热血动漫、精品纪录片等全品类内容。采用先进的视频转码技术和多线CDN加速方案，
            确保无论您身处何地，都能获得极速加载、不卡顿不缓冲的流畅播放体验。
          </p>
          <p>
            我们的内容团队每日精心筛选和更新片库，紧跟全球影视热点，
            第一时间为用户呈现最新最热的影视作品。51视频，让好内容触手可及。
          </p>
        </div>
      </div>
    </section>
  );
}